<router-outlet></router-outlet>

<!-- <div style="
position: absolute;
top: 3rem;
left: 3rem;
z-index: 99999;
">
    <div (click)="rechercheInsi()" style="
        background: red;
        border-radius: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        font-size: 1.4rem;
        cursor: pointer;
        padding: 1rem;
        margin: 0.5rem 0;
    ">Recherche INSI</div>

    <div (click)="getInsiFromVitale()" style="
        background: red;
        border-radius: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        font-size: 1.4rem;
        cursor: pointer;
        padding: 1rem;
        margin: 0.5rem 0;
    ">Get INSI from Vitale</div>

    <div (click)="rechercheDmp()" style="
        background: red;
        border-radius: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        font-size: 1.4rem;
        cursor: pointer;
        padding: 1rem;
        margin: 0.5rem 0;
    ">Recherche DMP</div>
</div> -->